import { render, staticRenderFns } from "./PreparationVisasMailPopup.vue?vue&type=template&id=896f402a&"
import script from "./PreparationVisasMailPopup.vue?vue&type=script&lang=js&"
export * from "./PreparationVisasMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports